<template>
  <div id="Dashboard">
    <Wrap class="lg">
      <div class="headline">
        <h2>{{ $t(`choices.${choice}`) }}</h2>
        <Btn
          v-if="choice !== 'none'"
          class="danger sm"
          @click="choice = 'none'">
          Į pradžią
        </Btn>
      </div>
      <Row v-if="choice === 'none'" class="choices">
        <Column :md="6" :sm="12">
          <Btn
            class="info lg"
            @click="choice = 'new'">
            Naujas užsakymas
          </Btn>
        </Column>
        <Column :md="6" :sm="12">
          <Btn
            class="info lg"
            @click="choice = 'update'">
            Papildymas
          </Btn>
        </Column>
      </Row>
      <ImportFormNew v-else-if="choice === 'new'" :importData="importData" />
      <UpdateForm v-else-if="choice === 'update'" :importData="importData" />
    </Wrap>
  </div>
</template>

<script>
import ImportFormNew from '../../components/forms/ImportFormNew'
import UpdateForm from '../../components/forms/UpdateForm'

export default {
  components: { ImportFormNew, UpdateForm },
  data() {
    return {
      choice: 'none',
    }
  },
}
</script>

<style lang="scss">
#Dashboard {
  display: flex;
  min-height: 100%;
  padding: 2rem 0;

  .Wrap {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  .headline {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;

    .Btn {
      max-width: 7rem;
    }
  }

  .choices {
    display: flex;
    margin-top: 30vh;

    .Btn {
      margin-bottom: 2rem;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "meta": {
      "title": {
        "complement": "Homepage",
        "inner": "AppMakers",
        "separator": "|"
      }
    },
    "title": "AppMakers",
    "button": "Documentation",
    "choices": {
      "none": "Pasirinkite",
      "new": "Naujas užsakymas",
      "update": "Užsakymo pildymas"
    }
  }
}
</i18n>
